<h2 mat-dialog-title>
  {{ 'OMNISEARCH.VIEW_PARTNER_OVERVIEW' | translate }}
</h2>
<div class="searchbox">
  <mat-form-field floatLabel="never">
    <input
      matInput
      #searchTerm
      [placeholder]="'OMNISEARCH.SEARCH_BY_PID' | translate"
      (keyup.enter)="goToOverview(searchTerm.value)"
    />
  </mat-form-field>
</div>
<mat-dialog-content>
  <mat-nav-list>
    <a
      mat-list-item
      tabindex="0"
      *ngFor="let partner of partners$ | async"
      (click)="goToOverview(partner.id)"
      (keyup.enter)="goToOverview(partner.id)"
    >
      <h4 matListItemTitle class="row-title">{{ partner.id }}</h4>
      <p matListItemLine>{{ partner.name }}</p>
    </a>
  </mat-nav-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
